<template>
    <div class="content" style="position: relative;">
        <div class="row">
            <div class="col-md-10 flex-container-top">
                <h2 class="text-eveer">Auto Notifications List</h2>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <card card-body-classes="table-full-width">
                    <div>
                        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <el-select class="select-primary mb-3 pagination-select" v-model="pagination.perPage"
                                placeholder="Per page">
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item"
                                    :label="item" :value="item" />
                            </el-select>
                            <base-input>
                                <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                                    placeholder="Search records" v-model="searchQuery" aria-controls="datatables" />
                            </base-input>
                        </div>
                        <el-table :data="tableData" style="font-size: 13px">
                            <el-table-column :min-width="180" align="left" label="Event name">
                                <div slot-scope="props">
                                    <div style="font-weight: 500; margin-bottom: 4px;">
                                        {{ props.row.event_id.event_name }}
                                    </div>
                                    <div style="font-weight: 300">
                                        ({{ props.row.event_id.date }})
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="500" align="left" label="Notification text">
                                <div slot-scope="props">
                                    <div style="font-weight: 500; margin-bottom: 4px;">
                                        {{ props.row.title }}
                                    </div>
                                    <div style="font-weight: 300">
                                        {{ props.row.message }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="180" align="left" label="Time">
                                <div slot-scope="props">
                                    <div>{{ getDateTime(props.row.created_at) }}</div>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            <p class="card-category">
                                Showing {{ from }} to {{ to }} of {{ pagination.total }} entries
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="pagination.total" />
                    </div>
                </card>
            </div>
        </div>

        <div class="row loader-pos" v-if="loading">
            <div class="sk-chase">
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
            </div>
        </div>
        <div v-if="loading" class="global-loading-overlay"></div>
        <div class="no-data-message" v-if="noDataMessage">
            <div>There are no records found</div>
        </div>
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import moment from "moment";
import debounce from 'lodash/debounce';

export default {
    components: {
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            role: localStorage.getItem("role"),
            noDataMessage: false,
            loading: false,
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 50, 100, 1000],
                total: 0
            },
            searchQuery: "",
            tableData: [],
            searchedData: [],
            fuseSearch: null
        };
    },
    computed: {
        from() {
            return this.tableData.length === 0 ? 0 : (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
        },
        to() {
            return this.from + this.tableData.length - 1;
        }
    },
    watch: {
        "pagination.currentPage"() {
            this.LoadNotifications();
        },
        "pagination.perPage"() {
            this.pagination.currentPage = 1;
            this.LoadNotifications();
        },
        searchQuery() {
            this.pagination.currentPage = 1;
            this.debouncedLoadNotifications();
        }
    },
    mounted() {
        this.LoadNotifications();
    },
    methods: {
        getDateTime(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        debouncedLoadNotifications: debounce(function () {
            this.LoadNotifications();
        }, 1000),
        async LoadNotifications() {
            this.loading = true;
            const { currentPage, perPage } = this.pagination;

            const res = await this.$apiService.getCall(`notification/get-auto-notifications?page=${currentPage}&limit=${perPage}&search=${this.searchQuery}`);

            const { Code, Data, total, page, Message } = res.apidata;

            if (Code === "P00001") {
                this.tableData = Data || [];
                this.pagination.total = total;
                this.pagination.currentPage = page;
                this.noDataMessage = this.tableData.length === 0 ? true : false;
                console.log(this.tableData.length)
            } else {
                this.$apiService.notify(Message);
            }
            this.loading = false;
        }
    }
};
</script>

<style>
.pagination-select,
.search-input {
    width: 200px;
}

.swal2-icon-content {
    font-size: inherit !important;
}

.group-img {
    width: 100%;
    max-width: 100px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
}

.icon-padding {
    padding: 10px;
}

.global-loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    pointer-events: all;
}
</style>